import PropTypes from 'prop-types';
import React from 'react';
import reactT from './../components/reactT';

class FederatedSearchFieldContainer extends React.Component {
  constructor(props) {
    super(props);

    // This will return the width of the viewport.
    const intFrameWidth = window.innerWidth;

    this.state = {
      // Filters are visible for large / hidden for small screens by default.
      expanded: intFrameWidth > 900,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleFiltersClick = this.handleFiltersClick.bind(this);
  }

  handleClick() {
    this.setState({
      expanded: !this.state.expanded,
    });
  }

  handleFiltersClick() {
    document.body.classList.toggle('facet-filters-opened');
  }

  render() {
    return (
      <div className="search-filters">
        <div className="block-facet-filters-block">
          <form className="search-filters__form w-100">
            <section className="search-accordion" aria-labelledby="section-title">
              <div className="filter-mobile-toggler">
                <span className="facet-filters-label" id="section-title">{reactT('Filters')}</span>
                <img src="/themes/custom/project/images/icons/filler-icon.svg" alt="filters icon" className="filters-icon" onClick={this.handleFiltersClick} />
                <img src="/themes/custom/project/images/icons/close.svg" alt="filters icon close" className="filters-icon-close" onClick={this.handleFiltersClick} />
              </div>
              <div><a href={window.location.pathname} className="reset-filter">{reactT('Reset all filters')}</a></div>
              { this.props.resultsCount > 0
                ? (<ul className="search-accordion__group">{this.props.children}</ul>)
                : <div className="search-filters__no-results">{reactT('No filters for the results of your search, try to use another Keyword/Date.')}</div> }
            </section>
          </form>
        </div>
      </div>
    );
  }
}

FederatedSearchFieldContainer.propTypes = {
  children: PropTypes.array,
  onNewSearch: PropTypes.func,
};

export default FederatedSearchFieldContainer;
